import React from 'react';
import { cva } from 'class-variance-authority';
import { cnMerge } from '../../../utils/utils';

export const Typography = ({
  as,
  fontVariant,
  textTransform,
  textAlign,
  className,
  children,
  ...props
}) => {
  const typographyVariants = cva('!text-customGray-900', {
    variants: {
      fontVariant: {
        default: 'text-clamp-md font-normal',
        h1: 'text-clamp-h1 font-bold',
        h2: 'text-clamp-h2 font-medium',
        h3: 'text-clamp-h3 font-medium',
        h4: 'text-clamp-h4 font-medium',
        h5: 'text-clamp-h5 font-medium',
        h6: 'text-clamp-h6 font-medium',
        h7: 'text-clamp-h7 font-medium',
        h8: 'text-clamp-h8 font-medium',
        xl: 'text-clamp-xl font-light',
        lg: 'text-clamp-lg font-light',
        md: 'text-clamp-md font-light',
        sm: 'text-clamp-sm font-light',
        xs: 'text-clamp-xs font-light',
        button: 'text-clamp-button font-medium',
        p1: 'text-clamp-p1 font-light',
        p2: 'text-clamp-p2 font-light',
      },
      textTransform: {
        default: 'normal-case',
        uppercase: 'uppercase',
        lowercase: 'lowercase',
        capitalize: 'capitalize',
        normal: 'normal-case',
      },
      textAlign: {
        default: 'text-center',
        left: 'text-left',
        right: 'text-right',
        center: 'text-center',
        justify: 'text-justify',
        inherit: 'text-inherit',
      },
    },
    defaultVariants: {
      fontVariant: 'default',
      textTransform: 'default',
      textAlign: 'default',
    },
  });

  const asMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    p: 'p',
    span: 'span',
    label: 'label',
    div: 'div',
  };

  const Element = asMapping[as] || 'p';

  return (
    <Element
      className={cnMerge(
        typographyVariants({
          fontVariant,
          textTransform,
          textAlign,
        }),
        className
      )}
      {...props}
    >
      {children}
    </Element>
  );
};
